import { post } from 'common/utils/request';
export var createSupportRequestUserApi = function (data) {
    return post('/support-requests/self', data, { contentType: 'multipart/form-data' });
};
export var createSupportRequestManagerApi = function (data) {
    return post('/support-requests', data, { contentType: 'multipart/form-data' });
};
